/* Keeping the bundles small when using import { faCoffee } relies on
  tree-shaking. If you are not using a tool that supports tree shaking
  you may end up bundling more icons than you intend. Here are some alternative
  import syntaxes:
 */

import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faSpinner,
  faCheckSquare,
  faPlusCircle,
  faSquare as fasSquare,
  faSync,
  faTrashAlt,
  faTrophy,
  faWrench,
  faAdjust,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faBrain,
  faCalendarAlt,
  faCaretDown,
  faCaretUp,
  faCaretRight as fasCaretRight,
  faCaretLeft as fasCaretLeft,
  faCheckCircle,
  faChevronCircleLeft,
  faChevronCircleRight,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChild,
  faClock,
  faCoffee,
  faCopy,
  faCut,
  faUndo,
  faRedo,
  faPenSquare,
  faReply,
  faForward,
  faDownload,
  faLanguage,
  faInfo,
  faPlug,
  faImage,
  faIdCard,
  faEdit,
  faEject,
  faExpand,
  faExternalLinkAlt,
  faLink,
  faFilter,
  faFolderOpen,
  faHome,
  faHourglassStart,
  faLock,
  faMinus,
  faMinusSquare,
  faPaperPlane,
  faPaste,
  faPauseCircle,
  faPen,
  faPlus,
  faPlusSquare as fasPlusSquare,
  faQuestionCircle,
  faSignOutAlt,
  faStopwatch,
  faTimes,
  faTrash,
  faUnlock,
  faUser,
  faUsers,
  faUserPlus as fasUserPlus,
  faArchive,
  faCog,
  faQuoteLeft,
  faInfoCircle,
  faPause,
  faPlay,
  faStop,
  faFastBackward,
  faFastForward,
  faAngleLeft,
  faAngleRight,
  faTasks,
  faSearch,
  faRobot,
  faLightbulb,
  faUserFriends,
  faImages,
  faBolt,
  faGripHorizontal,
  faGripVertical,
  faBullseye,
  faEye,
  faVoteYea,
  faEyeSlash as fasEyeSlash,
  faSlidersH,
  faCameraRetro,
  faShareAlt,
  faChessBoard,
  faShoePrints,
  faPrint,
  faMagic,
  faListAlt,
  faListOl,
  faTruck,
  faEllipsisV,
  faEllipsisH,
  faBrush,
  faStream,
  faTable,
  faShieldAlt,
  faTrashRestoreAlt,
  faEnvelopeOpenText,
  faBalanceScale,
  faFileUpload,
  faFileDownload,
  faPalette,
  faHandPaper,
  faStar as fasStar,
  faShare as fasShare,
  faShareSquare as fasShareSquare,
  faBookmark as fasBookmark,
  faHandshake as fasHandshake,
  faCamera as fasCamera,
  faBell as fasBell,
  faEnvelope as fasEnvelope,
  faPlaneDeparture as fasPlaneDeparture,
  faExpandArrowsAlt as fasExpandArrowsAlt,
  faCrown as fasCrown,
  faCircle as fasCirlce,
  faGripLines as fasGripLines,
  faLevelDownAlt as fasLevelDownAlt,
  faArrowDown as fasArrowDown,
  faArrowRight as fasArrowRight,
  faArrowUp as fasArrowUp,
  faFlagCheckered as fasFlagCheckered,
  faBug as fasBug,
  faArrowsAltH as fasArrowsAltH,
  faArrowsAltV as fasArrowsAltV,
  faExclamationCircle as fasExclamationCircle,
  faCheck as fasCheck,
  faThumbsUp as fasThumbsUp,
  faLocationArrow as fasLocationArrow,
  faTools as fasTools,
  faCloudDownloadAlt as fasCloudDownloadAlt,
  faColumns as fasColumns,
  faThLarge as fasThLarge
} from '@fortawesome/free-solid-svg-icons'

import {
  faPauseCircle as farPauseCircle,
  faPlayCircle as farPlayCircle,
  faStopCircle as farStopCircle,
  faComment as farComment,
  faCalendarCheck as farCalendarCheck,
  faCheckCircle as farCheckCircle,
  faStar as farStar,
  faShareSquare as farShareSquare,
  faBookmark as farBookmark,
  faHandshake as farHandshake,
  faSquare as farSquare,
  faBell as farBell,
  faEnvelope as farEnvelope,
  faPlusSquare as farPlusSquare,
  faCaretSquareDown as farCaretSquareDown,
  faCircle as farCircle,
  faEyeSlash as farEyeSlash,
  faThumbsUp as farThumbsUp,
} from '@fortawesome/free-regular-svg-icons'

import {
  faFortAwesome,
  faInternetExplorer,
  faTwitter,
  faGoogle
} from '@fortawesome/free-brands-svg-icons';

/* import {
  falSquare,
  falCheckSquare
} from '@fortawesome/pro-light-svg-icons'; */

library.add(farComment);
library.add(farCalendarCheck);
library.add(faCalendarAlt);
library.add(farCheckCircle);
library.add(farPauseCircle);
library.add(farPlayCircle);
library.add(farStopCircle);
library.add(farCircle);
library.add(farCaretSquareDown);
library.add(faBalanceScale);

library.add(faFortAwesome);
library.add(faInternetExplorer);
library.add(faTwitter);
library.add(faGoogle);
// library.add(falSquare);
// library.add(falCheckSquare);

library.add(faHandPaper);
library.add(faAdjust);
library.add(faAngleLeft);
library.add(faAngleRight);
library.add(faAngleDoubleLeft);
library.add(faAngleDoubleRight);
library.add(faArchive);
library.add(faTruck);
library.add(faCaretDown);
library.add(faEllipsisV)
library.add(faEllipsisH)
library.add(faBrush)
library.add(faStream)
library.add(faTable)
library.add(faShieldAlt)
library.add(faCaretUp);
library.add(fasCaretRight);
library.add(fasCaretLeft);
library.add(faCheckCircle);
library.add(faCheckSquare);
library.add(faChevronCircleLeft);
library.add(faChevronCircleRight);
library.add(faChevronDown);
library.add(faChevronLeft);
library.add(faChevronRight);
library.add(faChevronUp);
library.add(faChild);
library.add(faClock);
library.add(faCoffee);
library.add(faCog);
library.add(faCopy);
library.add(faCut);
library.add(faDownload);
library.add(faLanguage);
library.add(faInfo);
library.add(faPlug);
library.add(faImage);
library.add(faEdit);
library.add(faIdCard);
library.add(faEject);
library.add(faExpand);
library.add(faLink);
library.add(faExternalLinkAlt);
library.add(faFilter);
library.add(faFolderOpen);
library.add(faHome);
library.add(faHourglassStart);
library.add(faLock);
library.add(faMinus);
library.add(faMinusSquare);
library.add(faPaperPlane);
library.add(faPaste);
library.add(faPauseCircle);
library.add(faPen);
library.add(faPlus);
library.add(faPlusCircle);
library.add(farPlusSquare);
library.add(fasPlusSquare);
library.add(faQuestionCircle);
library.add(faQuoteLeft);
library.add(faSignOutAlt);
library.add(faSpinner);
library.add(farSquare);
library.add(fasSquare);
library.add(faStopwatch);
library.add(faSync);
library.add(faTimes);
library.add(faTrash);
library.add(faTrashAlt);
library.add(faEnvelopeOpenText);
library.add(faTrashRestoreAlt);
library.add(faTrophy);
library.add(faUnlock);
library.add(faUser);
library.add(faUsers);
library.add(fasUserPlus);
library.add(faWrench);
library.add(faInfoCircle);
library.add(faPause);
library.add(faPlay);
library.add(faStop);
library.add(faFastBackward);
library.add(faFastForward);
library.add(faMagic);
library.add(faListAlt);
library.add(faListOl);
library.add(fasBug);
library.add(faFileUpload);
library.add(faFileDownload);
library.add(faPalette);

library.add(faTasks);
library.add(faSearch);
library.add(faRobot);
library.add(faPlus);
library.add(faLightbulb);
library.add(faUserFriends);
library.add(faImages);
library.add(faBolt);
library.add(faGripHorizontal);
library.add(faGripVertical);
library.add(fasGripLines);
library.add(faBullseye);
library.add(faEye);
library.add(faVoteYea);
library.add(fasEyeSlash);
library.add(farEyeSlash);
library.add(faSlidersH);
library.add(faCameraRetro);
library.add(faShareAlt)
library.add(faBrain)
library.add(faChessBoard)
library.add(faShoePrints)
library.add(faPrint)
library.add(fasStar)
library.add(farStar)
library.add(fasShareSquare)
library.add(farShareSquare)
library.add(farBookmark)
library.add(fasBookmark)
library.add(fasHandshake)
library.add(farHandshake)
library.add(fasShare)
library.add(fasCamera)
library.add(farBell)
library.add(fasBell)
library.add(farEnvelope)
library.add(fasEnvelope)
library.add(fasPlaneDeparture)
library.add(fasExpandArrowsAlt)
library.add(fasCrown)
library.add(fasCirlce)
library.add(fasLevelDownAlt)
library.add(fasArrowDown)
library.add(fasArrowRight)
library.add(fasArrowUp)
library.add(fasFlagCheckered)
library.add(fasArrowsAltH)
library.add(fasArrowsAltV)
library.add(fasExclamationCircle)
library.add(fasCheck)
library.add(fasThumbsUp)
library.add(farThumbsUp)
library.add(fasTools)
library.add(fasLocationArrow)
library.add(faForward)
library.add(faReply)
library.add(faUndo)
library.add(faPenSquare)
library.add(faRedo)
library.add(fasCloudDownloadAlt)
library.add(fasColumns)
library.add(fasThLarge)

library.add({
  prefix: 'fas',
  iconName: 'drag-handle',
  icon: [
    24,
    24,
    [],
    'ff04',
    'M20 9H4v2h16V9zM4 15h16v-2H4v2z'
  ]
})

/* THES ICONS ARE COPYRIGHT PROTECTED !!! */

library.add({
  prefix: 'fas',
  iconName: 'noun-Toaster-216378',
  icon: [
    100,
    125,
    [],
    'ff01',
    'M97.957,59c-0.01-8.263-6.683-14.943-14.936-15v-0.001h-6.178c-1.544-10.041-18.606-12-26.887-12s-25.343,1.959-26.887,12  c-2.063,0-4.093,0.002-6.154,0.002C2,44,2,59,2,59v36c0,1.652,1.349,3,3,3h90c1.651,0,3.002-1.349,3-3L97.957,59z M49.957,34.999  c5.947,0,21.969,1.34,23.822,9H26.134C27.987,36.339,44.009,34.999,49.957,34.999z M5,95V59c0,0,0-12,11.957-12H83  c6.608,0.024,11.956,5.386,11.956,12L95,95H5z M20,68h-3v-4.5c0-0.828-0.672-1.5-1.5-1.5S14,62.672,14,63.5V68h-3  c-1.652,0-3,1.348-3,3v3c0,1.652,1.348,3,3,3h3v13.5c0,0.828,0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5V77h3c1.652,0,3-1.348,3-3v-3  C23,69.348,21.652,68,20,68z M20,74h-9v-3h9V74z M65,27.5c0,0.828-0.662,1.5-1.478,1.5s-1.478-0.671-1.478-1.5H62c0-6,3-6,3-12  s-3-6-3-12h0.044c0-0.828,0.662-1.5,1.478-1.5C64.338,2.001,65,2.672,65,3.5c0,6,3,6,3,12S65,21.5,65,27.5L65,27.5z M55.956,27.5  c0,0.828-0.662,1.499-1.478,1.499c-0.816,0-1.478-0.671-1.478-1.5v-0.038c0.013-5.961,3-5.974,3-11.961c0-6-3-6-3-12l0,0  C53,2.671,53.662,2,54.478,2s1.478,0.671,1.478,1.5l0,0H56c0,6,3,6,3,12s-3,6-3,12H55.956L55.956,27.5z M47,27.5  c0,0.828-0.662,1.5-1.478,1.5s-1.478-0.671-1.478-1.5h-0.043c0-6,3-6,3-12s-3-6-3-12h0.043c0-0.828,0.662-1.5,1.478-1.5  S47,2.672,47,3.5l0,0c0,6,3,6,3,12S47,21.5,47,27.5L47,27.5L47,27.5z M37.956,27.5c0,0.828-0.662,1.499-1.478,1.499  c-0.816,0-1.478-0.671-1.478-1.5v-0.038c0.013-5.96,3-5.974,3-11.961c0-6-3-6-3-12l0,0C35,2.671,35.662,2,36.478,2  c0.816,0,1.478,0.671,1.478,1.5l0,0H38c0,6,3,6,3,12s-3,6-3,12H37.956L37.956,27.5z M78.428,52.999H21.456  c-0.828,0-1.5,0.672-1.5,1.5s0.672,1.5,1.5,1.5h56.972c0.828,0,1.5-0.672,1.5-1.5S79.257,52.999,78.428,52.999L78.428,52.999z'
  ]
})

library.add({
  prefix: 'fas',
  iconName: 'noun-meditation-1471256',
  icon: [
    64,
    80,
    [],
    'ff02',
    'M53,47h-2.42L47,40.734V30c0-2.206-1.794-4-4-4V14v-1.001C43,6.626,38.374,2,32,2c-6.876,0-10.799,5.648-11,10.962  c0,0.013,0.007,0.025,0.007,0.038H21v13c-2.206,0-4,1.794-4,4v10.734L13.42,47H11c-1.654,0-3,1.346-3,3  c0,1.299,0.834,2.396,1.991,2.813C9.366,53.531,9,54.442,9,55.405c0,1.977,1.477,3.669,3.436,3.937l19.429,2.649  C31.91,61.997,31.955,62,32,62s0.09-0.003,0.135-0.009l19.429-2.649C53.523,59.074,55,57.382,55,55.405  c0-0.964-0.366-1.875-0.991-2.592C55.166,52.396,56,51.299,56,50C56,48.346,54.654,47,53,47z M45,30v11  c0,0.174,0.045,0.345,0.132,0.496l4,7C49.31,48.808,49.641,49,50,49h3c0.551,0,1,0.448,1,1s-0.449,1-1,1h-5.529l-6.365-7.705  l2.701-15.125C44.509,28.48,45,29.185,45,30z M25.684,30.948l6,2C31.787,32.982,31.893,33,32,33s0.213-0.018,0.316-0.052l6-2  C38.725,30.813,39,30.431,39,30v-2h2.719l-4.5,18H26.781l-4.5-18H25v2C25,30.431,25.275,30.813,25.684,30.948z M29.473,11.85  c0.001-0.001,0.002-0.001,0.003-0.002c0.308-0.167,0.612-0.341,0.91-0.526c0.065-0.04,0.129-0.082,0.194-0.123  c0.261-0.166,0.52-0.333,0.773-0.513c0.148-0.104,0.29-0.217,0.435-0.326c0.166-0.125,0.337-0.243,0.499-0.374  c0.029,0.099,0.078,0.19,0.111,0.288c0.089,0.257,0.176,0.516,0.294,0.759c0.013,0.027,0.031,0.05,0.044,0.076  c0.65,1.305,1.69,2.382,2.973,3.068c0.005,0.003,0.011,0.004,0.016,0.007c0.323,0.172,0.66,0.32,1.01,0.44  c0.102,0.035,0.212,0.05,0.316,0.08c0.259,0.075,0.516,0.154,0.786,0.199C38.215,14.967,38.604,15,39,15h0.443  c-0.889,2.387-2.754,4.408-4.841,5.38c-0.006,0.003-0.013,0.003-0.02,0.006c-0.436,0.201-0.863,0.351-1.285,0.452  c-0.01,0.002-0.019,0.005-0.029,0.008c-1.283,0.302-2.524,0.15-3.85-0.46c-0.036-0.017-0.074-0.023-0.111-0.035  c-2.438-1.16-4.51-3.743-5.12-6.63C26.039,13.376,27.82,12.744,29.473,11.85z M30,27v-4.277c0.304,0.081,0.61,0.145,0.918,0.189  c0.036,0.005,0.072,0.014,0.108,0.019C31.35,22.974,31.674,23,32,23c0.309,0,0.618-0.026,0.927-0.065  c0.077-0.01,0.154-0.026,0.231-0.038c0.251-0.04,0.5-0.091,0.749-0.155c0.031-0.008,0.062-0.011,0.094-0.019V27c0,0.553,0.448,1,1,1  h2v1.279l-5,1.667l-5-1.667V28h2C29.552,28,30,27.553,30,27z M32,53.987l-9.995-1.578L26.414,48h11.172l4.409,4.409L32,53.987z   M24.893,46.693l-5.569,5.569l-1.117-0.152l6.172-7.471L24.893,46.693z M44.676,52.262l-5.569-5.569l0.514-2.055l6.172,7.471  L44.676,52.262z M38,26h-2v-4.085c2.109-1.147,3.933-3.118,5-5.469V26H38z M32,4c5.299,0,9,3.7,9,8.999L39,13c-2.757,0-5-2.243-5-5  c0-0.404-0.244-0.77-0.617-0.924c-0.113-0.048-0.232-0.066-0.35-0.07C33.022,7.006,33.011,7,33,7c-0.02,0-0.038,0.01-0.057,0.011  c-0.09,0.005-0.178,0.022-0.263,0.052c-0.031,0.01-0.06,0.019-0.09,0.032c-0.108,0.049-0.21,0.111-0.297,0.198  c-2.468,2.469-5.721,4.08-9.176,4.565C23.759,7.86,26.879,4,32,4z M23,16.449c1.06,2.349,2.876,4.323,5,5.472V26h-2h-3V16.449z   M11,49h3c0.359,0,0.69-0.192,0.868-0.504l4-7C18.955,41.345,19,41.174,19,41V30c0-0.815,0.491-1.52,1.193-1.83l2.701,15.125  L16.529,51H11c-0.551,0-1-0.448-1-1S10.449,49,11,49z M32,59.991l-19.294-2.632C11.733,57.227,11,56.387,11,55.405  c0-0.569,0.246-1.111,0.675-1.485c0.362-0.316,0.823-0.487,1.297-0.487c0.088,0,0.177,0.006,0.266,0.019l18.415,2.511l5.353,3.346  L32,59.991z M51.294,57.359l-11.191,1.526l-5.229-3.268l15.886-2.167c0.567-0.082,1.134,0.094,1.564,0.469  C52.754,54.294,53,54.836,53,55.405C53,56.387,52.267,57.227,51.294,57.359z'
  ]
})

library.add({
  prefix: 'fas',
  iconName: 'sequence-icon',
  icon: [
    28,
    27,
    [],
    'ff03',
    /*
    M4.75641 6.85209V4.21713H3.73486V3.59602C3.87808 3.59967 4.01619 3.58871 4.14991 3.56387C4.28363 3.53829 4.40347 3.49445 4.50942 3.43014C4.61611 3.36657 4.70599 3.28181 4.77979 3.17732C4.85359 3.07282 4.90182 2.94349 4.92447 2.78857H5.58065V6.85136H4.75641V6.85209Z
    M21.5191 3.703C21.5805 3.50424 21.674 3.3296 21.7975 3.18054C21.9218 3.03147 22.0774 2.91602 22.2652 2.83198C22.453 2.74868 22.6685 2.70703 22.9126 2.70703C23.0982 2.70703 23.275 2.73626 23.4438 2.79399C23.6119 2.85244 23.7602 2.93502 23.8874 3.04389C24.0145 3.15277 24.1168 3.28576 24.1921 3.44433C24.2681 3.60289 24.3054 3.78119 24.3054 3.97848C24.3054 4.18381 24.2725 4.35918 24.2067 4.50679C24.1402 4.65366 24.0533 4.78446 23.9458 4.89845C23.8377 5.01244 23.7149 5.11621 23.5768 5.20901C23.4395 5.30181 23.3013 5.39388 23.1625 5.48449C23.0229 5.57583 22.887 5.67301 22.7555 5.77751C22.624 5.882 22.5078 6.00403 22.4069 6.14286H24.328V6.85093H21.3452C21.3452 6.61491 21.3788 6.40958 21.4468 6.23566C21.5147 6.06175 21.6068 5.90538 21.7223 5.76801C21.8385 5.63063 21.9751 5.50422 22.1322 5.38803C22.2886 5.27185 22.4537 5.1542 22.6284 5.03363C22.7175 4.97225 22.8125 4.90941 22.9133 4.84511C23.0142 4.78081 23.1055 4.71066 23.1888 4.6332C23.2721 4.55575 23.3415 4.46879 23.3978 4.37234C23.4541 4.27588 23.4818 4.16554 23.4818 4.04132C23.4818 3.84403 23.4248 3.69058 23.3108 3.58024C23.1969 3.4699 23.0507 3.41437 22.8724 3.41437C22.7526 3.41437 22.6503 3.44286 22.5677 3.4984C22.4844 3.55466 22.4179 3.62774 22.3675 3.71907C22.3178 3.81041 22.282 3.91052 22.2608 4.02086C22.2396 4.1312 22.2287 4.24081 22.2287 4.34895H21.4395C21.43 4.11732 21.457 3.90175 21.5191 3.703Z
    M4.91351 21.757C5.01435 21.7497 5.10788 21.727 5.19484 21.6905C5.28179 21.6532 5.3534 21.6006 5.40967 21.5304C5.46593 21.461 5.4937 21.3675 5.4937 21.252C5.4937 21.0781 5.43524 20.9444 5.31979 20.8516C5.2036 20.7588 5.07061 20.712 4.91936 20.712C4.71037 20.712 4.55327 20.7815 4.44658 20.9181C4.3399 21.0555 4.28875 21.2287 4.29313 21.4376H3.50907C3.51711 21.2287 3.55438 21.0379 3.62233 20.8662C3.68956 20.6945 3.78455 20.5462 3.90658 20.4227C4.02861 20.2985 4.17402 20.2027 4.34501 20.1348C4.51527 20.0668 4.70452 20.0332 4.91351 20.0332C5.07573 20.0332 5.23868 20.0573 5.4009 20.1055C5.56385 20.1538 5.70926 20.2268 5.83933 20.3233C5.9694 20.4205 6.07462 20.5381 6.15573 20.6777C6.23684 20.8165 6.27776 20.9773 6.27776 21.1592C6.27776 21.3565 6.23026 21.5304 6.13527 21.6817C6.04028 21.8322 5.89852 21.9353 5.70853 21.9893V22.001C5.93286 22.0507 6.10896 22.1596 6.23684 22.3255C6.36471 22.4928 6.42829 22.6916 6.42829 22.9232C6.42829 23.1358 6.38664 23.3258 6.30333 23.4917C6.22003 23.6583 6.10896 23.7979 5.9694 23.9097C5.83056 24.0215 5.6698 24.1069 5.48785 24.1654C5.3059 24.2231 5.11665 24.2524 4.91936 24.2524C4.69137 24.2524 4.48312 24.2195 4.29532 24.153C4.10753 24.0872 3.94823 23.9915 3.8167 23.8658C3.68517 23.7401 3.5836 23.5859 3.51199 23.404C3.44038 23.2221 3.40677 23.0138 3.41042 22.7778H4.19375C4.19741 22.8859 4.21494 22.9897 4.24563 23.0883C4.27632 23.187 4.32163 23.2725 4.37936 23.3441C4.43781 23.4157 4.51015 23.4727 4.59711 23.5151C4.68406 23.5575 4.78783 23.5786 4.90766 23.5786C5.09327 23.5786 5.24964 23.5216 5.37752 23.4077C5.50539 23.2937 5.56896 23.138 5.56896 22.9407C5.56896 22.7858 5.539 22.6674 5.47908 22.5863C5.41917 22.5059 5.34244 22.4468 5.24964 22.4095C5.15684 22.373 5.05527 22.3518 4.94493 22.3459C4.83459 22.3401 4.72937 22.3372 4.62853 22.3372V21.757C4.71841 21.765 4.8134 21.765 4.91351 21.757Z
    */
    `M4.83808 9.67323C7.50927 9.67323 9.6747 7.50781 9.6747 4.83662C9.6747 2.16543 7.50927 0 4.83808 0C2.16689 0 0.00146484 2.16543 0.00146484 4.83662C0.00146484 7.50781 2.16689 9.67323 4.83808 9.67323Z
    M4.83735 26.9999C7.50894 26.9999 9.67469 24.8341 9.67469 22.1625C9.67469 19.4909 7.50894 17.3252 4.83735 17.3252C2.16575 17.3252 0 19.4909 0 22.1625C0 24.8341 2.16575 26.9999 4.83735 26.9999Z
    M22.7536 9.67323C25.4248 9.67323 27.5902 7.50781 27.5902 4.83662C27.5902 2.16543 25.4248 0 22.7536 0C20.0824 0 17.917 2.16543 17.917 4.83662C17.917 7.50781 20.0824 9.67323 22.7536 9.67323Z
    M22.7543 26.9999C25.4259 26.9999 27.5917 24.8341 27.5917 22.1625C27.5917 19.4909 25.4259 17.3252 22.7543 17.3252C20.0827 17.3252 17.917 19.4909 17.917 22.1625C17.917 24.8341 20.0827 26.9999 22.7543 26.9999Z
    M21.769 24.8991L19.4365 22.2817L20.1658 21.632L21.8223 23.4917L25.3948 20.0479L26.0722 20.7515L21.769 24.8991Z
    M15.4163 4.4043H9.67432V5.27093H15.4163V4.4043Z
    M13.6919 6.30613L15.1621 4.83739L13.6919 3.36865H14.9392L16.408 4.83739L14.9392 6.30613H13.6919Z
    M15.4163 21.7305H9.67432V22.5971H15.4163V21.7305Z
    M13.6919 23.6323L15.1621 22.1643L13.6926 20.6948L14.9392 20.6956L16.408 22.1643L14.9392 23.6323H13.6919Z
    M19.8577 9.62574L19.2988 8.96338L9.8967 16.8967L10.4556 17.5591L19.8577 9.62574Z
    M10.5486 14.9937L10.374 17.0638L12.4441 17.2377L11.4913 18.0422L9.42188 17.8683L9.59652 15.7989L10.5486 14.9937Z`
  ]
})

library.add({
  prefix: 'far',
  iconName: 'plus-circle',
  icon: [
    512,
    512,
    [],
    'f055',
    'M384 240v32c0 6.6-5.4 12-12 12h-88v88c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-88h-88c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h88v-88c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v88h88c6.6 0 12 5.4 12 12zm120 16c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-48 0c0-110.5-89.5-200-200-200S56 145.5 56 256s89.5 200 200 200 200-89.5 200-200z'
  ]
})

library.add({
  prefix: 'fas',
  iconName: 'goalpilot',
  icon: [
    27,
    30,
    [],
    'ff04',
    'M19.7734 3.58015L19.7753 10.7433L13.4819 14.3263L7.18738 10.7462V3.5802L13.4999 0L19.7734 3.58015ZM0 15.7185V8.55817L6.3059 12.1334L6.31445 12.1285L12.6205 15.7039L12.6293 15.6989L12.6293 30L6.32321 26.4247L6.31445 26.4297L6.31445 19.2888L0.00855717 15.7136L0 15.7185ZM20.5361 12.1335L26.8422 8.55817L26.8422 15.7185L26.8334 15.7135L20.5273 19.2888V26.4297L20.5188 26.4248L14.2129 30L14.2129 15.6989L14.2214 15.7038L20.5273 12.1285L20.5361 12.1335Z'
  ]
})

export default library;
